module.exports = __webpack_public_path__ + "img/evergreen.d9728c39.jpeg";